import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-type-donor-moral.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetTypeDonorMoralDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metTypeDonorMoralEntity = useAppSelector(state => state.metTypeDonorMoral.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metTypeDonorMoralDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.detail.title">MetTypeDonorMoral</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metTypeDonorMoralEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.code">Code</Translate>
            </span>
          </dt>
          <dd>{metTypeDonorMoralEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.name">Name</Translate>
            </span>
          </dt>
          <dd>{metTypeDonorMoralEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{metTypeDonorMoralEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{metTypeDonorMoralEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.status">Status</Translate>
            </span>
          </dt>
          <dd>{metTypeDonorMoralEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-type-donor-moral" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-type-donor-moral/${metTypeDonorMoralEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetTypeDonorMoralDetail;
